/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        allowComment: {
    type: 'boolean',
    isRequired: true,
},
        order: {
    type: 'number',
    isRequired: true,
},
        assignee: {
    type: 'number',
    isNullable: true,
},
        departmentId: {
    type: 'number',
    isNullable: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        subTitle: {
    type: 'string',
    isRequired: true,
},
    },
};